module.exports = __webpack_public_path__ + "static/media/upgrade-service.8f5a440e.png";